import { Filter, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ClaimsToolbarProps {
  readonly keyword: string;
  readonly filterOpen: boolean;
  readonly resetEnabled: boolean;
  onKeywordChange: (value: string) => void;
  onToggleFilter: () => void;
  onReset: () => void;
}

/** Heading, keyword search, and the Filter / Reset pair (US-009 AC-005, US-010 AC-001). */
export function ClaimsToolbar({
  keyword,
  filterOpen,
  resetEnabled,
  onKeywordChange,
  onToggleFilter,
  onReset,
}: ClaimsToolbarProps): React.JSX.Element {
  return (
      <div className="border-line flex flex-wrap items-center justify-between gap-3 border-b pb-3">
        <h2 id="claims-heading" className="text-brand-600 text-lg font-bold">
          Claims
        </h2>

        <div className="flex flex-wrap items-center gap-2">
          <input
            type="search"
            aria-label="Search claims"
            placeholder="Search claims"
            value={keyword}
            onChange={(event): void => {
              onKeywordChange(event.target.value);
            }}
            className="border-line focus:border-brand-600 h-9 w-48 rounded-md border bg-surface-muted px-3 text-[13px] focus:bg-surface"
          />
          <Button
            type="button"
            variant="secondary"
            size="sm"
            aria-expanded={filterOpen}
            onClick={onToggleFilter}
            className="gap-1.5"
          >
            <Filter aria-hidden="true" className="h-3.5 w-3.5" />
            Filter
          </Button>
          <Button
            type="button"
            variant="secondary"
            size="sm"
            disabled={!resetEnabled}
            onClick={onReset}
            className="gap-1.5"
          >
            <RotateCcw aria-hidden="true" className="h-3.5 w-3.5" />
            Reset
          </Button>
        </div>
      </div>

  );
}
